function globalModalPopup(id) {
  var content = jQuery("#" + id).html();

  var template =
    '<div id="pu_placeholder" style="display:none;">' +
    '  <div id="bg-click-modal">' +
    '    <div class="modal-popup js-modal-wrapper">' +
    '      <div class="pu-modal-container pu-page-width">' +
    '        <div id="modalPU">' +
    '          <header class="modal-header">' +
    "            <h2>Information</h2>" +
    '            <div class="modal-close" onclick="closeGlobalModalPU();">&times;</div>' +
    "          </header>" +
    '          <div class="modal-body">' +
    content +
    "          </div>" +
    "        </div>" +
    "      </div>" +
    "    </div>" +
    '    <div class="pu-modal-overlay"></div>' +
    "  </div>" +
    "</div>";

  jQuery("BODY").append(template);
  var scrolled = jQuery(document).scrollTop();
  var wHeight = jQuery(window).height();
  jQuery("#pu_placeholder").show();
  var modalHeight = jQuery("#modalPU").outerHeight();
  var topModal = wHeight / 2 - modalHeight / 2;
  var topPoint = scrolled + topModal;
  jQuery(".js-modal-wrapper").css("top", topPoint + "px");
  initBackgroundClick();
}

function initBackgroundClick() {
  jQuery("#bg-click-modal").mouseup(function (e) {
    var container = jQuery(".modal-popup");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      closeGlobalModalPU();
    }
  });
}

function closeGlobalModalPU() {
  // jQuery('#pu_placeholder').hide();
  jQuery("#pu_placeholder").remove();
}

function getZipPopData() {
  var tmpStr =
    '<iframe class="zip-popup" width="900" height="775" src="https://static.zipmoney.com.au/assets/default/modal/au/zip-modal-au.html"></iframe>';
  return tmpStr;
}

function getAfterPayData() {
  var tmpStr =
    "<picture>" +
    '<source media="(max-width: 767px)" srcset="https://cdn.shopify.com/s/files/1/0680/6850/7907/files/afterpay_mobile.png?v=1749009236">' +
    '<source media="(min-width: 768px)" srcset="https://cdn.shopify.com/s/files/1/0680/6850/7907/files/afterpay_desktop.png?v=1749009212">' +
    '<img src="https://static.afterpay.com/lightbox-desktop" srcset="https://cdn.shopify.com/s/files/1/0680/6850/7907/files/afterpay_desktop.png?v=1749009212" alt="How Afterpay works">' +
    "</picture>";
  return tmpStr;
}

function getShipRestrict(country) {
  let msg =
    '<div class="restrict-modal">Due to export regulations and/or manufacturers restrictions, this item can not be shipped to ' +
    country +
    " <p>&nbsp;</p>Please try searching for a similar item from a different brand or model.</div>";
  return msg;
}

function getShipRestrictCart(prodlist, country) {
  let ids = prodlist.split(",");
  let listing = "";
  ids.forEach(function (id) {
    prodId = id.trim();
    prod_img = $('[data-id="' + prodId + '"] .image img').attr("src");
    prod_title = $(
      '[data-id="' + prodId + '"] .cart__form-item-title a'
    ).html();
    listing +=
      '<div class="restricted-item">' +
      '<div class="restricted-item-img">' +
      '<img src="' +
      prod_img +
      '" title="' +
      prod_title +
      '" />' +
      "</div>" +
      '<div class="restricted-item-title">' +
      " " +
      prod_title +
      " " +
      "</div>" +
      "</div>";
  });

  let msg =
    '<div class="restrict-modal">' +
    '<div class="restrict-modal-title">Manufacturer\'s restrictions prevent us from completing an order to ' +
    country +
    " on the following items:</div>" +
    listing +
    "</div>";
  return msg;
}

function globalModalPopupDirect(heading, content, width, headless = false) {
  var page_width = "pu-page-width";
  let modalClass = "modal-standard";

  if (width == "S") {
    page_width = "pu-page-width-small";
  }
  if (width == "L") {
    page_width = "pu-page-width-large";
  }
  if (width == "X") {
    page_width = "pu-page-width-extra-large";
  }
  if (width == "D") {
    page_width = "pu-page-width-deep";
  }
  if (headless) {
    modalClass = "modal-headless";
    page_width = "pu-page-width-headless";
  }
  if (heading == "") {
    heading = "Alert";
  }
  var template =
    '<div id="pu_placeholder" style="display:none;">' +
    '  <div id="bg-click-modal">' +
    '    <div class="modal-popup js-modal-wrapper">' +
    '      <div class="pu-modal-container ' +
    page_width +
    '">' +
    '        <div id="modalPU" class="' +
    modalClass +
    '">' +
    '		  <div class="modal-title">' +
    heading +
    "		  </div>" +
    '          <div class="modal-close" onclick="closeGlobalModalPU();">&times;</div>' +
    '          <div class="modal-body">' +
    content +
    "          </div>" +
    "        </div>" +
    "      </div>" +
    "    </div>" +
    '    <div class="pu-modal-overlay"></div>' +
    "  </div>" +
    "</div>";

  jQuery("BODY").append(template);
  var scrolled = jQuery(document).scrollTop();
  var wHeight = jQuery(window).height();
  jQuery("#pu_placeholder").show();
  var modalHeight = jQuery("#modalPU").outerHeight();
  var topModal = wHeight / 2 - modalHeight / 2;
  var topPoint = scrolled + topModal;
  if (topPoint < 0) {
    topPoint = 0;
  }
  jQuery(".js-modal-wrapper").css("top", topPoint + "px");
  initBackgroundClick();
}

function initBackgroundClick() {
  // if the function hideCart() exists, call it
  if (typeof hideCart === "function") {
    hideCart();
  } else {
    $(".quick-cart__close-icon").click();
    $(".quick-cart__wrapper").removeClass("active");
  }
  jQuery("#bg-click-modal").mouseup(function (e) {
    var container = jQuery(".modal-popup");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      closeGlobalModalPU();
    }
  });
}

function closeGlobalModalPU() {
  // jQuery('#pu_placeholder').hide();
  jQuery("#pu_placeholder").remove();
}

function scrollToTabs(selector) {
  isMobile = false;
  if (jQuery("BODY").hasClass("is-mobile")) {
    isMobile = true;
  }
  let destination =
    jQuery(".product-tabs__tab-buttons-wrapper").offset().top - 75;
  if (isMobile) {
    jQuery(".accordion__inner[data-open='true'] .accordion__label").click();
    console.log("Mobile");
    if (selector == "O") {
      destination =
        jQuery(".product-tabs__mobile-accordions").offset().top - 67;
      jQuery("#product_description_MFkjzc .accordion__label").click();
    }
    if (selector == "S") {
      destination =
        jQuery(".product-tabs__mobile-accordions").offset().top - 18;
      jQuery("#one_column_JJBTCa .accordion__label").click();
    }
    if (selector == "W") {
      destination =
        jQuery(".product-tabs__mobile-accordions").offset().top + 29;
      jQuery("#one_column_iKLpNE .accordion__label").click();
    }
    if (selector == "R") {
      destination =
        jQuery(".product-tabs__mobile-accordions").offset().top + 75;
      jQuery("#one_column_gKhVrA .accordion__label").click();
    }
  } else {
    if (selector == "O") {
      jQuery(
        '[aria-controls="product-tab--product_description_MFkjzc"]'
      ).click();
    }
    if (selector == "S") {
      jQuery('[aria-controls="product-tab--one_column_JJBTCa"]').click();
    }
    if (selector == "W") {
      jQuery('[aria-controls="product-tab--one_column_iKLpNEE"]').click();
    }
    if (selector == "R") {
      jQuery('[aria-controls="product-tab--one_column_gKhVrA"]').click();
    }
  }
  jQuery("html, body").stop().animate(
    {
      scrollTop: destination,
    },
    1000
  );
}

function scrollToDataIndex(dataIndex, modifier) {
  let destination =
    jQuery(
      "#shopify-section-template--17783441228035__collapsible_row_list_JYLUiJ .collapsible-row-list-item[data-index='" +
        dataIndex +
        "']"
    ).offset().top + modifier;
  jQuery("html, body").stop().animate(
    {
      scrollTop: destination,
    },
    1000
  );
}

jQuery(function () {
  jQuery(".quick-links__link").click(function () {
    var buttonText = removeHtmlTags(jQuery(this).text());
    buttonText = buttonText.replace(/\n/g, "");
    buttonText = buttonText.trim();
    console.log(buttonText);
    if (buttonText == "Customer Support") {
      scrollToDataIndex(0, -75);
    }
    if (buttonText == "Returns - Refund Policy") {
      scrollToDataIndex(7, -75);
    }
    if (buttonText == "Payment Methods") {
      scrollToDataIndex(5, -75);
    }
    if (buttonText == "Ready to receive your order?") {
      scrollToDataIndex(6, -75);
    }
    if (buttonText == "Warranty and Service") {
      scrollToDataIndex(8, -75);
    }
  });
  initSearchBox();
  initAgree();
  initPageLinkListener();
  initLinkActivePageClass();
  // collapseAllButFirstDetails();
  initTabsRefresh();
  initTippyTip();
});

function initTippyTip(){
  // if .tippytip exists then apply tippy tooltip
  tippy(".tippytip", {
    content(reference) {
        const tooltipId = reference.getAttribute("data-tooltip");
        const contentElement = document.getElementById(tooltipId);

        // Return the HTML content if it exists, otherwise a fallback
        return contentElement ?
            contentElement.innerHTML :
            "Tooltip content not found!";
    },
    allowHTML: true, // Enable HTML in tooltips
    theme: "light", // Optional: Use a light theme for styling
    maxWidth: 300, // Optional: Set max width of the tooltip
    placement: "top", // Tooltip position
});

}

function initTabsRefresh() {
  setupLinkToButtonClick(".hideOver", ".overtab", 200);
  setupLinkToButtonClick(".hideSpecs", ".specstab", 200);
}
function setupLinkToButtonClick(linkClass, buttonClass, delay = 500) {
  const interval = setInterval(() => {
    const $links = $(linkClass);

    if ($links.length) {
      $links.each(function () {
        const $link = $(this);

        // Prevent rebinding
        if (!$link.data("specsClickBound")) {
          $link.data("specsClickBound", true);

          // Capture the original inline onclick handler
          const originalClick = this.onclick;

          // Detach the inline handler so we can fully control it
          this.onclick = null;

          $link.on("click", function (e) {
            e.preventDefault(); // prevent navigation only (not inline logic)

            // Re-run the original onclick, if it exists
            if (typeof originalClick === "function") {
              originalClick.call(this, e);
            }

            // Delay before clicking the button
            setTimeout(() => {
              const $button = $(buttonClass);
              if ($button.length) {
                console.log("Triggering button click...");
                $button.trigger("click");
              } else {
                console.warn("Button not found:", buttonClass);
              }
            }, delay);
          });
        }
      });

      clearInterval(interval);
    }
  }, 300);
}

function initLinkActivePageClass() {
  if (!$("BODY").hasClass("template-page")) {
    return;
  }
  var currentPath = window.location.pathname;

  $("a[href]").each(function () {
    var linkPath = $("<a>", { href: $(this).attr("href") })[0].pathname;
    if (linkPath === currentPath) {
      $(this).addClass("active-page");
    }
  });
}

function removeHtmlTags(text) {
  return text.replace(/<[^>]+>/g, "");
}

function listReveal(id) {
  console.log(id);
  let btn = $("#reveal__features_" + id);
  console.log(btn.html());
  if (btn.html() == "Show more ▼") {
    btn.html("Show less &#9650;");
    var parent = btn.closest(".listing_main-features-wrapper");
    parent.removeClass("closed");
    parent.addClass("open");
  } else {
    btn.html("Show more &#9660;");
    var parent = btn.closest(".listing_main-features-wrapper");
    parent.removeClass("open");
    parent.addClass("closed");
  }
}

function initSearchBox() {
  let sb = $("#QuickSearchInputdesktop");
  let btn = $(".quick-search__submit.main-search");
  sb.keyup(function () {
    var searchText = sb.val();
    if (searchText.length > 0) {
      // Perform some action when there is text in the search box
      console.log("Search box is not empty");
      btn.attr("disabled", false);
    } else {
      // Perform some action when the search box is empty
      console.log("Search box is empty");
      btn.attr("disabled", true);
    }
  });
}

// Special GLaDOS code //
// Function to add the "glados" class to the "clever-search-toggler" element
function addGladosClass() {
  const element = document.querySelector("clever-search-toggler");
  if (element && !element.classList.contains("glados")) {
    element.classList.add("glados");
  }
}

// Create a new MutationObserver instance
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      // Check if the "clever-search-toggler" element is added
      addGladosClass();
    }
  }
});

// Start observing the document body for childList changes
observer.observe(document.body, { childList: true, subtree: true });

// Optionally, call the function initially in case the element is already present
// document.addEventListener('DOMContentLoaded', () => {
//     addGladosClass();
// });

function initAgree() {
  $(document).off("click.vgCartTerms").on(
    "click.vgCartTerms",
    '.cart__input-buttons [name="checkout"], .quick-cart__footer [name="checkout"]',
    function (event) {
      const $checkoutArea = $(this).closest(
        ".cart__input-buttons, .quick-cart__footer"
      );
      const $agreement = $checkoutArea.find("[data-cart-terms-checkbox]");

      // Never lock customers out if the checkbox markup is unavailable.
      if (!$agreement.length || $agreement.is(":checked")) {
        return true;
      }

      event.preventDefault();
      alert(
        $agreement.attr("data-terms-error") ||
          "You must agree with the terms and conditions of sales to check out."
      );
      $agreement.trigger("focus");
      return false;
    }
  );
}

function initPageLinkListener() {
  $(document).off("click.vgPagePopup").on(
    "click.vgPagePopup",
    ".page_popup",
    function (e) {
      e.preventDefault();
      const page = $(this).attr("data-page-url") || $(this).attr("rel");
      const pageTitle = $(this).attr("title");

      if (!page) return false;

      $.get(page, function (data) {
        const $html = $(data);
        let sectionContent = $html.find('[data-section-type="page"]').html();
        sectionContent =
          '<div style="text-align: left;">' + sectionContent + "</div>";
        globalModalPopupDirect(pageTitle, sectionContent, "X", false);
      });

      return false;
    }
  );
}

// Accessories link on product page

let executed = false;

const activateTab = function () {
  if (!executed && window.location.hash === "#Accessories") {
    executed = true;

    $("html, body").animate(
      {
        scrollTop: $(".product-tabs__inner").offset().top - 100,
      },
      500
    );

    // Open Accessories tab
    $("button:contains('Accessories')").click();
  }
};

// Run after scroll stabilization
let lastScrollTop = $(window).scrollTop();
let scrollCheckInterval = setInterval(function () {
  let currentScrollTop = $(window).scrollTop();

  if (currentScrollTop === lastScrollTop) {
    clearInterval(scrollCheckInterval);
    // activateTab();
    setTimeout(activateTab, 2750);
  }

  lastScrollTop = currentScrollTop;
}, 100);

function expandDetails(pref1, pref2, id) {
  const currentBox = $("#" + pref1 + id);
  const state = currentBox.attr("rel");

  if (state === "minus") {
    const $thishead = $("#" + pref1 + id);
    const $thisbox = $("#" + pref2 + id);
    $thisbox.slideUp("fast");
    $thishead.removeClass("minus").addClass("plus").attr("rel", "plus");
    return;
  }

  // Slide down the selected detail section
  const $detailToOpen = $("#" + pref2 + id);
  $detailToOpen.slideDown("fast", function () {
    // Mark bullet as expanded
    currentBox.removeClass("plus").addClass("minus").attr("rel", "minus");
  });
}

function collapseAllButFirstDetails() {
  jQuery(".hideDetail").each(function (index) {
    var detailId = jQuery(this).attr("id");
    var id = detailId.split("_")[1];

    if (index === 0) {
      // Keep first open
      jQuery(this).show();
      jQuery("#hb_" + id)
        .removeClass("plus")
        .addClass("minus")
        .attr("rel", "minus");
    } else {
      // Hide the rest
      jQuery(this).hide();
      jQuery("#hb_" + id)
        .removeClass("minus")
        .addClass("plus")
        .attr("rel", "plus");
    }
  });
}
